import React, { useState } from 'react'
import { LuLayoutDashboard } from 'react-icons/lu'
import { FaUserGroup } from 'react-icons/fa6'
import { IoCalendarNumberOutline } from 'react-icons/io5'
import { RiFileCheckLine } from 'react-icons/ri'
import { IoMenuOutline, IoCloseOutline } from 'react-icons/io5'
import { MdOutlinePolicy } from 'react-icons/md'
import { Link, useLocation } from 'react-router-dom'
import { IoIosArrowForward } from 'react-icons/io'
import { MdOutlinePayments } from 'react-icons/md'
import { BiLogOutCircle } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
import { deleteCookie } from '../../utils/api/cookies'
import { toast } from 'react-toastify'

const Sidebar = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)

  const logOut = () => {
    deleteCookie('token')
    toast.success('Logged out successfully')
    navigate('/login')
  }

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: <LuLayoutDashboard size={20} />,
      link: '/',
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: <FaUserGroup size={20} />,
      link: '/employee',
    },
    {
      id: 'attendance',
      label: 'Attendance',
      icon: <RiFileCheckLine size={20} />,
      link: '/attendance',
    },
    {
      id: 'salary',
      label: 'Salary',
      icon: <MdOutlinePayments size={20} />,
      link: '/salary',
    },
    {
      id: 'holidays',
      label: 'Holidays',
      icon: <IoCalendarNumberOutline size={20} />,
      link: '/holidays',
    },
    {
      id: 'leavePolicy',
      label: 'LeavePolicy',
      icon: <MdOutlinePolicy size={20} />,
      link: '/leavePolicy',
    },
    {
      id: 'logout',
      label: 'LogOut',
      icon: <BiLogOutCircle size={20} />,
      onClick: logOut,
    },
  ]

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      {/* Mobile Menu Toggle */}
      <button
        onClick={toggleSidebar}
        className='md:hidden fixed top-4 -left-4 bg-tan text-right  text-white p-2 rounded-full shadow-lg z-10'
      >
        {isOpen ? (
          <IoCloseOutline className='' size={24} />
        ) : (
          <IoIosArrowForward className='ml-2' size={24} />
        )}
      </button>

      {/* <button
          onClick={toggleMenu}
          className='md:hidden fixed top-4 left-4 bg-link text-white p-2 rounded-full shadow-lg z-10'
        >
          {isOpen ? <IoCloseOutline size={24} /> : <IoMenuOutline size={24} />}
        </button> */}

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-cream shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
      >
        <div className='h-full flex flex-col'>
          {/* Header */}
          <div className='p-4 bg-cream border-b flex justify-between items-center'>
            <h2 className='text-xl font-bold text-brown'>HR Portal</h2>
            <button onClick={toggleSidebar} className='md:hidden text-black'>
              <IoCloseOutline size={24} />
            </button>
          </div>

          {/* Menu Items */}
          <nav className='flex-grow overflow-y-auto p-4'>
            {menuItems.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg mb-2 ${
                  location.pathname === item.link
                    ? 'bg-tan text-white'
                    : 'text-black hover:bg-tan/30'
                } transition-colors`}
                onClick={item.onClick ? item.onClick : toggleSidebar}
              >
                {item.icon}
                <span className='text-sm font-medium'>{item.label}</span>
              </Link>
            ))}
          </nav>

          {/* Footer */}

          <div className='p-4 flex bg-light_gray border-t'>
            <div className='flex items-center space-x-3'>
              <img
                src={'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'}
                alt={'profile'}
                className='w-10 h-10 rounded-full object-cover'
              />
              <div>
                <p className='text-sm font-medium text-brown'>Admin</p>
                <p className='text-xs text-gray-500'>Administrator</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className='fixed inset-0 bg-black opacity-50 z-30 md:hidden'
          onClick={toggleSidebar}
        />
      )}
    </>
  )
}

export default Sidebar
